export { default as TabList, TabDivider } from "./component";
export { default as TabGroup } from "./TabGroup";
export { default as Tab } from "./Tab";
